import { MotifProgressLoader } from "../../../assets/lib/motif";
import "./LoadingIndicatorEmbed.scss";

export function LoadingIndicatorEmbed({
  show,
  fullscreen = false,
  children,
  className = "",
  ...props
}) {
  return (
    <>
      <MotifProgressLoader
        show={show}
        fullscreen={fullscreen}
        className={`decarb-loading-indicator-embed ${className}`}
        {...props}
      >
        {children}
      </MotifProgressLoader>
    </>
  );
}
